import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';
import AddJob from './pages/AddJob';
import EditJob from './pages/EditJob';
import AddCandidate from './pages/AddCandidate';
import ImportCandidates from './pages/ImportCandidates';
import Candidates from './pages/Candidates';
import CandidateDetail from './pages/CandidateDetail';
import PIProfiles from './pages/PIProfiles';
import AdminDashboard from './pages/AdminDashboard';
import CandidateDeduplication from './pages/CandidateDeduplication';
import OAuthCallbackSimple from './pages/OAuthCallbackSimple';
import Profile from './pages/Profile';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Settings from './pages/Settings';
import Teams from './pages/Teams';
import TeamDetail from './pages/TeamDetail';
import PrivateRoute from './components/PrivateRoute';
import ErrorBoundary from './components/ErrorBoundary';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
    h6: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <NotificationProvider>
          <AuthProvider>
            <Router>
              <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/login/oauth-success" element={<OAuthCallbackSimple />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="jobs" element={<Jobs />} />
                <Route path="jobs/new" element={<AddJob />} />
                <Route path="jobs/:id" element={<JobDetail />} />
                <Route path="jobs/:id/edit" element={<EditJob />} />
                <Route path="jobs/:jobId/add-candidate" element={<AddCandidate />} />
                <Route path="jobs/:jobId/import-candidates" element={<ImportCandidates />} />
                <Route path="jobs/:jobId/candidates/:candidateId" element={<CandidateDetail />} />
                <Route path="candidates" element={<Candidates />} />
                <Route path="candidates/import" element={<ImportCandidates />} />
                <Route path="candidates/:id" element={<CandidateDetail />} />
                <Route path="teams" element={<Teams />} />
                <Route path="teams/:id" element={<TeamDetail />} />
                <Route path="pi-profiles" element={<PIProfiles />} />
                <Route path="profile" element={<Profile />} />
                <Route path="admin" element={<AdminDashboard />} />
                <Route path="admin/deduplication" element={<CandidateDeduplication />} />
                <Route path="settings" element={<Settings />} />
              </Route>
            </Routes>
          </Router>
        </AuthProvider>
      </NotificationProvider>
    </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
